import { Tag, type TagProps } from '@innovationnorway/cl-react';
import React, { useMemo } from 'react';
import { SivaGoalsStatus } from 'src/api/v2';

type Props = {
  status: SivaGoalsStatus;
};

const SivaGoalTag: React.FC<Props> = ({ status }) => {
  const text = useMemo(() => {
    switch (status) {
      case SivaGoalsStatus.Draft:
        return 'Utkast';
      case SivaGoalsStatus.Approved:
        return 'Godkjent';
      case SivaGoalsStatus.ChangeRequested:
        return 'Sendt tilbake';
      case SivaGoalsStatus.Submitted:
        return 'Innsendt';
      default:
        return status;
    }
  }, [status]);

  const color = useMemo<TagProps['data-color']>(() => {
    switch (status) {
      case SivaGoalsStatus.Approved:
        return 'success';
      case SivaGoalsStatus.ChangeRequested:
        return 'danger';
      case SivaGoalsStatus.Submitted:
        return 'info';
      default:
        return 'neutral';
    }
  }, [status]);

  return <Tag data-color={color}>{text}</Tag>;
};

export default SivaGoalTag;
